import { __decorate, __metadata } from 'tslib';
import { Injectable, NgModule } from '@angular/core';
import { ConfigOauthService, ApiService, UiBsOauthModule } from '@wlp/ui-bs-oauth';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

let ConfigService = class ConfigService extends ConfigOauthService {
};
ConfigService = __decorate([
    Injectable()
], ConfigService);

const SPE_J_CASHOUT = '/spe-j-cash-out';
let SpeJCashOutProxy = class SpeJCashOutProxy {
    constructor(api) {
        this.api = api;
    }
    getAccountbydocument(uuidWhiteLabel, document) {
        const uri = `${SPE_J_CASHOUT}/api/ted/check-document/white-label/${uuidWhiteLabel}/document/${document}`;
        return this.api.get(uri);
    }
    /**
     * @description Consulta se a conta pertence ao mesmo balde de contas
     * @param uuidWhiteLabel
     * @param document
     * @param uuidAccountPayment
    */
    checkAccountSameBucket(uuidWhiteLabel, document, uuidAccountPayment) {
        const uri = `${SPE_J_CASHOUT}/api/ted/check-document/white-label/${uuidWhiteLabel}/document/${document}/account/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
    /**
     * @description Método envia os dados para efetuar a tranferência
     * @param uuidWhiteLabel
     * @param document
     * @param transferBody
    */
    effectTransfer(uuidWhiteLabel, document, transferBody) {
        const uri = `${SPE_J_CASHOUT}/api/ted/execute-operation/white-label/${uuidWhiteLabel}/document/${document}`;
        // uuidAccountPayment
        return this.api.post(uri, transferBody, transferBody.uuidAccountPayment);
    }
    /**
     * @description Proxy que tem a responsabilidade por validar
     * o codigo de barras informado
     * @param code
     */
    postBillet(code, isBarCode, uuidWhiteLabel, uuidAccountPayment) {
        const data = {
            lineConsult: code,
            isBarCode: isBarCode,
            uuidWhiteLabel: uuidWhiteLabel,
            uuidAccountPayment: uuidAccountPayment,
        };
        const uri = `${SPE_J_CASHOUT}/api/payment/consult`;
        return this.api.post(uri, data, uuidAccountPayment);
    }
    /**
     * @description Proxy que se comunica com a rota responsavel
     * por confirmar o pagamento de boleto e pegar os dados do extrato
     *
     * @param uuid
     */
    postBilletConfirm(data) {
        const uri = `${SPE_J_CASHOUT}/api/payment`;
        return this.api.post(uri, data, data.uuidAccountPayment);
    }
    postLiquidation(uuidAccountPayment, data) {
        const uri = `${SPE_J_CASHOUT}/api/billet/liquidation`;
        return this.api.post(uri, data, uuidAccountPayment);
    }
    pixTransaction(data) {
        const uri = `${SPE_J_CASHOUT}/api/pix/transaction/`;
        return this.api.post(uri, data, data.uuidAccountPayment);
    }
    pixCheckReturnAllowed(transactionId, returnValue) {
        const uri = `${SPE_J_CASHOUT}/api/pix/transaction/check-return-allowed/${transactionId}/?returnValue=${returnValue}`;
        return this.api.post(uri);
    }
    confirmTransaction(statusAproved, transactionsBody) {
        const uri = `${SPE_J_CASHOUT}/api/transaction-pending/confirm/${statusAproved}`;
        return this.api.post(uri, transactionsBody);
    }
    statusUpdateTransactionPending(uuidAccountPayment, updateStatusData) {
        const uri = `${SPE_J_CASHOUT}/api/update-transaction-pending/change-status`;
        return this.api.put(uri, updateStatusData, uuidAccountPayment);
    }
    canceledLotTransactionsPendingOfDualAuth(updateStatusData) {
        const uri = `${SPE_J_CASHOUT}/api/update-transaction-pending/canceled`;
        return this.api.put(uri, updateStatusData);
    }
};
SpeJCashOutProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeJCashOutProxy);

const SPE_J_CHECK_EVENT = '/spe-j-check-event';
let SpeJCheckEventProxy = class SpeJCheckEventProxy {
    constructor(api) {
        this.api = api;
    }
    /**
     * @description Valida se a operação está autorizada
     * @param checkEventBody
     */
    validateOperation(checkEventBody) {
        const uri = `${SPE_J_CHECK_EVENT}/api/check-event/`;
        return this.api.post(uri, checkEventBody);
    }
    checkDayResource(uuidWhiteLabel, code, type, dateOperation) {
        if (dateOperation) {
            const uri = `${SPE_J_CHECK_EVENT}/api/check-day/dayoff/white-label/${uuidWhiteLabel}/operation-code/${code}/type/${type}/?date-operation=${dateOperation}`;
            return this.api.get(uri);
        }
        else {
            const uri = `${SPE_J_CHECK_EVENT}/api/check-day/dayoff/white-label/${uuidWhiteLabel}/operation-code/${code}/type/${type}`;
            return this.api.get(uri);
        }
    }
};
SpeJCheckEventProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeJCheckEventProxy);

const SPE_J_FILES = '/spe-j-files';
let SpeJFilesProxy = class SpeJFilesProxy {
    constructor(api) {
        this.api = api;
    }
    downloadStatement(content) {
        const uri = `${SPE_J_FILES}/api/html-to-pdf`;
        return this.api.postBlob(uri, { content: content });
    }
};
SpeJFilesProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeJFilesProxy);

const SPE_J_FUNDS = '/spe-j-funds';
let SpeJFundsProxy = class SpeJFundsProxy {
    constructor(api) {
        this.api = api;
    }
    getCheckStatement(uuidWhilabel, uuidAccountPayment, dateInitial, dateEnd) {
        const uri = `${SPE_J_FUNDS}/api/statement/white-label/${uuidWhilabel}/account-payment/${uuidAccountPayment}?startDate=${dateInitial}&endDate=${dateEnd}`;
        return this.api.get(uri);
    }
    getCheckStatementFuture(uuidWhilabel, uuidAccountPayment) {
        const uri = `${SPE_J_FUNDS}/api/statement/future/white-label/${uuidWhilabel}/account-payment/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
    getCheckStatementCard(uuidWhilabel, uuidAccountPayment, dateInitial, dateEnd) {
        const uri = `${SPE_J_FUNDS}/api/statement/card/white-label/${uuidWhilabel}/account-payment/${uuidAccountPayment}?startDate=${dateInitial}&endDate=${dateEnd}`;
        return this.api.get(uri);
    }
    getCheckStatementByCard(uuidWhilabel, uuidAccountPayment, uuidAccountPaymentCard, dateInitial, dateEnd) {
        const uri = `${SPE_J_FUNDS}/api/statement/card/white-label/${uuidWhilabel}/account-payment/${uuidAccountPayment}/account-payment-card/${uuidAccountPaymentCard}?startDate=${dateInitial}&endDate=${dateEnd}`;
        return this.api.get(uri);
    }
    getCheckStatementPIX(uuidWhilabel, uuidAccountPayment, dateInitial, dateEnd) {
        const uri = `${SPE_J_FUNDS}/api/statement/pix/white-label/${uuidWhilabel}/account-payment/${uuidAccountPayment}?startDate=${dateInitial}&endDate=${dateEnd}`;
        return this.api.get(uri);
    }
    getLatestTransactionPix(uuidWhilabel, uuidAccountPayment, quantity, typeOrigin) {
        /* const uri = `${SPE_J_FUNDS}/api/statement/pix/white-label/${uuidWhilabel}/account-payment/${uuidAccountPayment}?quantity=${quantity}`; */
        const uri = `${SPE_J_FUNDS}/api/statement/last-registers/type-origin/${typeOrigin}/white-label/${uuidWhilabel}/account-payment/${uuidAccountPayment}/number/${quantity}`;
        return this.api.get(uri);
    }
    getCheckStatementDevolutionPix(uuidWhilabel, uuidAccountPayment) {
        const uri = `${SPE_J_FUNDS}/api/statement/pix-can-be-returned/white-label/${uuidWhilabel}/account-payment/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
    getClientLimitAvaiable(uuidWl, uuidAccountPayment) {
        const uri = `${SPE_J_FUNDS}/api/limits/white-label/${uuidWl}/account-payment/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
    getClientLimitAvaiablePIX(uuidWl, uuidAccountPayment) {
        const uri = `${SPE_J_FUNDS}/api/limits/pix/white-label/${uuidWl}/account-payment/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
};
SpeJFundsProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeJFundsProxy);

const SPE_N_ACCOUNT = '/spe-n-account';
let SpeNAccountProxy = class SpeNAccountProxy {
    constructor(api) {
        this.api = api;
    }
    postCard(uuid) {
        const uri = `${SPE_N_ACCOUNT}/v1/add-card/${uuid}`;
        return this.api.post(uri);
    }
};
SpeNAccountProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeNAccountProxy);

const SPE_N_ACCOUNT$1 = '/spe-n-accounts';
let SpeNAccountsProxy = class SpeNAccountsProxy {
    constructor(api) {
        this.api = api;
    }
    decodeQrcode(uuidAccountPaymentPay, encode) {
        const uri = `${SPE_N_ACCOUNT$1}/v1/decode-qr-onus`;
        return this.api.post(uri, { encode, uuidAccountPaymentPay });
    }
    requestLimitRate(limitRateObj) {
        const uri = `${SPE_N_ACCOUNT$1}/v1/request-limit`;
        return this.api.post(uri, limitRateObj);
    }
    deleteTransactionSchedule(uuidAccountPayment, uuid) {
        const uri = `${SPE_N_ACCOUNT$1}/v1/transaction-schedule/${uuid}`;
        return this.api.delete(uri, uuidAccountPayment).pipe(map((result) => {
            return result;
        }), catchError((err) => {
            return of(err);
        }));
    }
    requestLimitPix(limitRateObj) {
        const uri = `${SPE_N_ACCOUNT$1}/v1/request-pix-limit`;
        return this.api.post(uri, limitRateObj);
    }
};
SpeNAccountsProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeNAccountsProxy);

const SPE_N_OPEN_ACCOUNT = '/spe-n-open-account';
let SpeNOpenAccountProxy = class SpeNOpenAccountProxy {
    constructor(api) {
        this.api = api;
    }
    getCep(zipcode) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/cep/${zipcode}`;
        return this.api.get(uri);
    }
};
SpeNOpenAccountProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeNOpenAccountProxy);

const SPE_N_PAYMENT_VOUNCHER = '/spe-view-n-payment-voucher';
let SpeNPaymentVoucherProxy = class SpeNPaymentVoucherProxy {
    constructor(api) {
        this.api = api;
    }
    findTransactionIdConsult(transactionIdConsult) {
        const uri = `${SPE_N_PAYMENT_VOUNCHER}/v1/voucher/transaction-id/${transactionIdConsult}`;
        return this.api.get(uri);
    }
    findTransactionIdConsultv2(transactionIdConsult) {
        const uri = `${SPE_N_PAYMENT_VOUNCHER}/v2/voucher/transaction-id/${transactionIdConsult}`;
        return this.api.get(uri);
    }
    findUuidWhiteLabel(uuidWhiteLabel) {
        const uri = `${SPE_N_PAYMENT_VOUNCHER}/v1/voucher/whitelabel/${uuidWhiteLabel}`;
        return this.api.get(uri);
    }
    findAllAccountPayment(uuidAccount) {
        const uri = `${SPE_N_PAYMENT_VOUNCHER}/v1/voucher/account-payment/${uuidAccount}`;
        return this.api.get(uri);
    }
    findAllScheduled(uuidAccount) {
        const uri = `${SPE_N_PAYMENT_VOUNCHER}/v1/voucher/scheduled/${uuidAccount}`;
        return this.api.get(uri);
    }
    findBarCode(barCode) {
        const uri = `${SPE_N_PAYMENT_VOUNCHER}/v1/voucher/barcode/${barCode}`;
        return this.api.get(uri);
    }
    findPeriodByAccountPayment(uuidAccount, startDate, endDate) {
        const uri = `${SPE_N_PAYMENT_VOUNCHER}/v1/voucher/account-payment/${uuidAccount}/period/?startDate=${startDate}&endDate=${endDate}`;
        return this.api.get(uri);
    }
    findPeriodByAccountPaymentAndTypeVoucher(uuidAccount, typeVoucher, startDate, endDate) {
        const uri = `${SPE_N_PAYMENT_VOUNCHER}/v1/voucher/account-payment/${uuidAccount}/type-voucher/${typeVoucher}/period/?startDate=${startDate}&endDate=${endDate}`;
        return this.api.get(uri);
    }
    findPeriodByAccountPaymentAndAccountDestination(uuidAccount, accountDestination, startDate, endDate) {
        const uri = `${SPE_N_PAYMENT_VOUNCHER}/v1/voucher/account-payment/${uuidAccount}/account-destination/${accountDestination}/period/?startDate=${startDate}&endDate=${endDate}`;
        return this.api.get(uri);
    }
    findPeriodByAccountPaymentAndDocumentDestination(uuidAccount, documentDestination, startDate, endDate) {
        const uri = `${SPE_N_PAYMENT_VOUNCHER}/v1/voucher/account-payment/${uuidAccount}/document-destination/${documentDestination}/period/?startDate=${startDate}&endDate=${endDate}`;
        return this.api.get(uri);
    }
    findAllPendingTransactions() {
        const uri = `${SPE_N_PAYMENT_VOUNCHER}/v1/transaction-pending/`;
        return this.api.get(uri);
    }
    findVoucherPaginated(uuidAccountPayment, startDate, endDate, type, paginationParams) {
        let params = '';
        if (startDate) {
            params += `?startDate=${startDate}`;
        }
        if (endDate) {
            const operator = params.length > 0 ? '&' : '?';
            params += `${operator}endDate=${endDate}`;
        }
        if (type) {
            const operator = params.length > 0 ? '&' : '?';
            params += `${operator}type=${type}`;
        }
        if (paginationParams) {
            const operator = params.length > 0 ? '&' : '?';
            params += `${operator}page=${paginationParams.page}&itemsPerPage=${paginationParams.itemsPerPage}`;
        }
        const uri = `${SPE_N_PAYMENT_VOUNCHER}/v1/voucher/account-payment/${uuidAccountPayment}/paginated${params}`;
        return this.api.get(uri);
    }
    findVoucherTemplatesByFilter(filter) {
        let params = '';
        if (filter.startDate) {
            params += `?startDate=${filter.startDate}`;
        }
        if (filter.endDate) {
            const operator = params.length > 0 ? '&' : '?';
            params += `${operator}endDate=${filter.endDate}`;
        }
        if (filter.type) {
            const operator = params.length > 0 ? '&' : '?';
            params += `${operator}type=${filter.type}`;
        }
        if (filter.excludeTransactionsIdsFromSearch) {
            const operator = params.length > 0 ? '&' : '?';
            params += `${operator}excludeTransactionsIdsFromSearch=${filter.excludeTransactionsIdsFromSearch}`;
        }
        const uri = `${SPE_N_PAYMENT_VOUNCHER}/v1/voucher/template/account-payment/${filter.uuidAccountPayment}/advanced${params}`;
        return this.api.get(uri);
    }
    findVouchersByTransactiosnId(transactionId) {
        const uri = `${SPE_N_PAYMENT_VOUNCHER}/v2/voucher/transactions-id/emitted/?transactionsId=${transactionId}`;
        return this.api.get(uri);
    }
};
SpeNPaymentVoucherProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeNPaymentVoucherProxy);

const SPE_VIEW_N_ACCOUNT = '/spe-view-n-account';
let SpeViewNAccountProxy = class SpeViewNAccountProxy {
    constructor(api) {
        this.api = api;
    }
    getAccountPaymentPerson(uuidAccountPayment) {
        const uri = `${SPE_VIEW_N_ACCOUNT}/v1/account-payment-person/account-payment/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
    getClientLimitRate(uuidWl, uuidAccountPayment) {
        const uri = `${SPE_VIEW_N_ACCOUNT}/v1/limit-rate/white-label/${uuidWl}/account-payment/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
    getTaxesTariff(uuidWl, uuidAccount) {
        const uri = `${SPE_VIEW_N_ACCOUNT}/v1/taxes-tariff/white-label/${uuidWl}/account-payment/${uuidAccount}/`;
        return this.api.get(uri);
    }
    getTransactionSchedule(uuidAccount) {
        const uri = `${SPE_VIEW_N_ACCOUNT}/v1/transaction-schedule/${uuidAccount}`;
        return this.api.get(uri);
    }
    findByUuidAccountPaymentAndBetweenDate(dateStart, dateEnd) {
        const uri = `${SPE_VIEW_N_ACCOUNT}/v1/cnab/conciliation/start/${dateStart}/end/${dateEnd}`;
        return this.api.get(uri);
    }
    findScheduledPaginated(startDate, endDate, searchValue, paginationParams) {
        let params = '';
        if (startDate) {
            params += `?startDate=${startDate}`;
        }
        if (endDate) {
            const operator = params.length > 0 ? '&' : '?';
            params += `${operator}endDate=${endDate}`;
        }
        if (searchValue) {
            const operator = params.length > 0 ? '&' : '?';
            params += `${operator}searchValue=${searchValue}`;
        }
        if (paginationParams) {
            const operator = params.length > 0 ? '&' : '?';
            params += `${operator}page=${paginationParams.page}&itemsPerPage=${paginationParams.itemsPerPage}`;
        }
        const uri = `${SPE_VIEW_N_ACCOUNT}/v1/transaction-schedule${params}`;
        return this.api.get(uri);
    }
    findScheduledVoucherTemplatesByFilter(filter) {
        let params = '';
        if (filter.startDate) {
            params += `?startDate=${filter.startDate}`;
        }
        if (filter.endDate) {
            const operator = params.length > 0 ? '&' : '?';
            params += `${operator}endDate=${filter.endDate}`;
        }
        if (filter.searchValue) {
            const operator = params.length > 0 ? '&' : '?';
            params += `${operator}searchValue=${filter.searchValue}`;
        }
        if (filter.excludeTransactionsIdsFromSearch) {
            const operator = params.length > 0 ? '&' : '?';
            params += `${operator}excludeTransactionsIdsFromSearch=${filter.excludeTransactionsIdsFromSearch}`;
        }
        const uri = `${SPE_VIEW_N_ACCOUNT}/v1/transaction-schedule-template${params}`;
        return this.api.get(uri);
    }
    getAllTransactionsPaginated(uuidAccountPayment, typeOperation, statusTransaction, dateStart, dateEnd, itemsPerPage = 20, pageNumber = 1) {
        const filterParams = `?typeOperation=${typeOperation}&statusTransaction=${statusTransaction}&dateStart=${dateStart}&dateEnd=${dateEnd}&itemPerPage=${itemsPerPage}&pageNumber=${pageNumber}`;
        const uri = `${SPE_VIEW_N_ACCOUNT}/v1/transaction-approve/track-approval${filterParams}`;
        return this.api.get(uri, [{ name: "X-Request-Uac", value: uuidAccountPayment }]);
    }
    getAllTransactionsPaginatedOfUser(uuidAccountPayment, typeOperation, statusTransaction, dateStart, dateEnd, itemsPerPage = 20, pageNumber = 1) {
        const filterParams = `?typeOperation=${typeOperation}&statusTransaction=${statusTransaction}&dateStart=${dateStart}&dateEnd=${dateEnd}&itemPerPage=${itemsPerPage}&pageNumber=${pageNumber}`;
        const uri = `${SPE_VIEW_N_ACCOUNT}/v1/transaction-approve/of-user/track-approval${filterParams}`;
        return this.api.get(uri, [{ name: "X-Request-Uac", value: uuidAccountPayment }]);
    }
};
SpeViewNAccountProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeViewNAccountProxy);

const SPE_VIEW_N_DASHBOARD_CLIENT = '/spe-view-n-dashboard-client';
let SpeViewNDashboardClientProxy = class SpeViewNDashboardClientProxy {
    constructor(api) {
        this.api = api;
    }
    downloadStatement(uuidWhiteLabel, uuidAccountPayment, startDate, endDate, format, colorCredit, colorDebit) {
        const uri = `${SPE_VIEW_N_DASHBOARD_CLIENT}/v1/downloads/statement/white-label/${uuidWhiteLabel}/account-payment/${uuidAccountPayment}?startDate=${startDate}&endDate=${endDate}&format=${format}&colorCredit=${colorCredit}&colorDebit=${colorDebit}`;
        return format == 'pdf' ? this.api.get(uri) : this.api.getBlob(uri);
    }
    downloadStatementByCard(uuidWhiteLabel, uuidAccount, dateInitial, dateEnd, uuidAccountPaymentCard, format, cardNumber, nickName, colorCredit, colorDebit) {
        const uri = `${SPE_VIEW_N_DASHBOARD_CLIENT}/v1/downloads/statementByCard/white-label/${uuidWhiteLabel}/account-payment/${uuidAccount}/card/${uuidAccountPaymentCard}?startDate=${dateInitial}&endDate=${dateEnd}&format=${format}&cardNumber=${cardNumber}&nickName=${nickName}&colorCredit=${colorCredit}&colorDebit=${colorDebit}`;
        return format == 'pdf' ? this.api.get(uri) : this.api.getBlob(uri);
    }
};
SpeViewNDashboardClientProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeViewNDashboardClientProxy);

const SPE_VIEW_N_BACKOFFICE_ACCOUNT = '/spe-view-n-backoffice-account';
let SpeViewNBackoficceAccountProxy = class SpeViewNBackoficceAccountProxy {
    constructor(api) {
        this.api = api;
    }
    getDualAuthAccountInfo(uuidAccountPayment) {
        const uri = `${SPE_VIEW_N_BACKOFFICE_ACCOUNT}/v1/configuration-approve/of-account/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
};
SpeViewNBackoficceAccountProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeViewNBackoficceAccountProxy);

const SPE_J_CNAB = '/spe-j-cnab';
let SpeJCnabProxy = class SpeJCnabProxy {
    constructor(api) {
        this.api = api;
    }
    downloadExtractConciliation(idNoSql) {
        const uri = `${SPE_J_CNAB}/api/240/extract/download/${idNoSql}`;
        return this.api.getBlob(uri);
    }
    /**
     * @description Método envia os dados para efetuar o processamento de arquivo
     *
     * @param uuidWhiteLabel
     * @param requestCnab
     */
    processFile(codeProduct, requestCnab) {
        let uri;
        switch (codeProduct) {
            case 1:
                uri = `${SPE_J_CNAB}/api/240/process`;
                break;
            case 2:
                uri = `${SPE_J_CNAB}/api/400/process`;
                break;
            default:
                throw new Error('Opção de codigo de produto invalida');
        }
        return this.api.post(uri, requestCnab, null);
    }
    donwoloadCnab(codeProduct, idNoSql) {
        let uri;
        switch (codeProduct) {
            case 1:
                uri = `${SPE_J_CNAB}/api/240/of-lot/${idNoSql}/download`;
                break;
            case 2:
                uri = `${SPE_J_CNAB}/api/400/of-lot/${idNoSql}/download`;
                break;
            default:
                throw new Error('Opção de codigo de produto invalida');
        }
        return this.api.getBlob(uri);
    }
    b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;
        let byteCharacters = atob(b64Data);
        let byteArrays = [];
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            let slice = byteCharacters.slice(offset, offset + sliceSize);
            let byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            let byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        let blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }
};
SpeJCnabProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeJCnabProxy);

const SPE_VIEW_N_STATAMENT = '/spe-view-n-statament';
let SpeViewNStatamentProxy = class SpeViewNStatamentProxy {
    constructor(api) {
        this.api = api;
    }
    findExtractByTypeView(uuidAccountPayment, startDate, endDate, typeView, uuidOperation) {
        const encodedStartDate = encodeURIComponent(startDate);
        const encodedEndDate = encodeURIComponent(endDate);
        if (uuidOperation !== undefined) {
            const uri = `${SPE_VIEW_N_STATAMENT}/v1/extract/of-ac/${uuidAccountPayment}?startDate=${encodedStartDate}&endDate=${encodedEndDate}&typeView=${typeView}&uuidOperation=${uuidOperation}`;
            return this.api.get(uri);
        }
        else {
            const uri = `${SPE_VIEW_N_STATAMENT}/v1/extract/of-ac/${uuidAccountPayment}?startDate=${encodedStartDate}&endDate=${encodedEndDate}&typeView=${typeView}`;
            return this.api.get(uri);
        }
    }
    findExtractByTypeViewPagination(uuidAccountPayment, startDate, endDate, typeView, page, pageSize, orderDate, uuidOperation) {
        const encodedStartDate = encodeURIComponent(startDate);
        const encodedEndDate = encodeURIComponent(endDate);
        const orderDateParam = `&orderDate=${orderDate}`;
        const paramComplemetary = uuidOperation && uuidOperation !== '' ? `&uuidOperation=${uuidOperation}` : '';
        const uri = `${SPE_VIEW_N_STATAMENT}/v1/extract/of-ac/${uuidAccountPayment}/paginated?startDate=${encodedStartDate}&endDate=${encodedEndDate}&typeView=${typeView}&page=${page}&itemsPerPage=${pageSize}${paramComplemetary}${orderDateParam}`;
        return this.api.get(uri);
    }
    findByTypeOperation(uuidAccountPayment, type) {
        const encodedType = encodeURIComponent(type);
        const uri = `${SPE_VIEW_N_STATAMENT}/v1/operation/of-ac/${uuidAccountPayment}?types=${encodedType}`;
        return this.api.get(uri);
    }
    downloadStatement(uuidWhiteLabel, uuidAccountPayment, startDate, endDate, typeView, format, uuidOperation, colorCredit, colorDebit) {
        const encodedStartDate = encodeURIComponent(startDate);
        const encodedEndDate = encodeURIComponent(endDate);
        let paramComplemetary = '';
        if (uuidOperation)
            paramComplemetary += `&uuidOperation=${uuidOperation ? uuidOperation : ''}`;
        if (colorCredit)
            paramComplemetary += `&colorCredit=${colorCredit ? colorCredit : ''}`;
        if (colorDebit)
            paramComplemetary += `&colorDebit=${colorDebit ? colorDebit : ''}`;
        const uri = `${SPE_VIEW_N_STATAMENT}/v1/download/${uuidWhiteLabel}/${uuidAccountPayment}?startDate=${encodedStartDate}&endDate=${encodedEndDate}&typeView=${typeView}&format=${format}${paramComplemetary}`;
        return format == 'pdf' ? this.api.get(uri) : this.api.getBlob(uri);
    }
    downloadStatementPagination(uuidWhiteLabel, uuidAccountPayment, startDate, endDate, typeView, format, uuidOperation, colorCredit, colorDebit) {
        const encodedStartDate = encodeURIComponent(startDate);
        const encodedEndDate = encodeURIComponent(endDate);
        let paramComplemetary = '';
        if (uuidOperation)
            paramComplemetary += `&uuidOperation=${uuidOperation ? uuidOperation : ''}`;
        if (colorCredit)
            paramComplemetary += `&colorCredit=${colorCredit ? colorCredit : ''}`;
        if (colorDebit)
            paramComplemetary += `&colorDebit=${colorDebit ? colorDebit : ''}`;
        const uri = `${SPE_VIEW_N_STATAMENT}/v1/download/${uuidWhiteLabel}/${uuidAccountPayment}/paginated?startDate=${encodedStartDate}&endDate=${encodedEndDate}&typeView=${typeView}&format=${format}${paramComplemetary}`;
        return format == 'pdf' ? this.api.get(uri) : this.api.getBlob(uri);
    }
};
SpeViewNStatamentProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeViewNStatamentProxy);

const SPE_VIEW_N_CNAB = '/spe-view-n-cnab';
let SpeViewNCnabProxy = class SpeViewNCnabProxy {
    constructor(api) {
        this.api = api;
    }
    getLotCnabByIdAndCodeProduct(codeProduct, idLot) {
        const uri = `${SPE_VIEW_N_CNAB}/v1/of-lot/${idLot}/code-product/${codeProduct}`;
        return this.api.get(uri);
    }
    getCnabDataByCodeProductAndPeriod(codeProduct, dateStart, dateEnd) {
        const uri = `${SPE_VIEW_N_CNAB}/v1/code-product/${codeProduct}/start/${dateStart}/end/${dateEnd}`;
        return this.api.get(uri);
    }
};
SpeViewNCnabProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeViewNCnabProxy);

const SPE_N_PAYMENT = '/spe-n-payment';
let SpeNPaymentProxy = class SpeNPaymentProxy {
    constructor(api) {
        this.api = api;
    }
    // ------------------------------------------------------------------------------
    // BILLET:: Start
    // ------------------------------------------------------------------------------
    addBilletLotByUser(paymentDetail) {
        const uri = `${SPE_N_PAYMENT}/v1/billet/`;
        return this.api.post(uri, paymentDetail);
    }
    deletedBilletLotByUser() {
        const uri = `${SPE_N_PAYMENT}/v1/billet/`;
        return this.api.delete(uri);
    }
    // Transaction
    addBilletLotTransaction(paymentDetail) {
        const uri = `${SPE_N_PAYMENT}/v1/billet/transaction`;
        return this.api.post(uri, paymentDetail);
    }
    updateBilletLotTransaction(paymentDetail) {
        const uri = `${SPE_N_PAYMENT}/v1/billet/transaction`;
        return this.api.put(uri, paymentDetail);
    }
    deletedBilletLotTransaction(uuidTransaction) {
        const uri = `${SPE_N_PAYMENT}/v1/billet/transaction/${uuidTransaction}`;
        return this.api.delete(uri);
    }
    processBillet(codeAuthorization, uuidPaymentLot, uuidWhiteLabel) {
        const uri = `${SPE_N_PAYMENT}/v1/billet/process`;
        return this.api.post(uri, { codeAuthorization: codeAuthorization, uuidPaymentLot: uuidPaymentLot, uuidWhiteLabel: uuidWhiteLabel });
    }
};
SpeNPaymentProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeNPaymentProxy);

const SPE_VIEW_N_PAYMENT = '/spe-view-n-payment';
let SpeViewNPaymentProxy = class SpeViewNPaymentProxy {
    constructor(api) {
        this.api = api;
    }
    getBilletLotAvailable() {
        const uri = `${SPE_VIEW_N_PAYMENT}/v1/billet`;
        return this.api.get(uri);
    }
};
SpeViewNPaymentProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeViewNPaymentProxy);

let UiPxCashOutModule = class UiPxCashOutModule {
};
UiPxCashOutModule = __decorate([
    NgModule({
        declarations: [],
        imports: [
            UiBsOauthModule
        ],
        providers: [
            ConfigService,
            SpeJCashOutProxy,
            SpeJCheckEventProxy,
            SpeJFundsProxy,
            SpeNAccountProxy,
            SpeNAccountsProxy,
            SpeNOpenAccountProxy,
            SpeNPaymentVoucherProxy,
            SpeViewNAccountProxy,
            SpeViewNDashboardClientProxy,
            SpeJFilesProxy,
            SpeViewNBackoficceAccountProxy,
            SpeJCnabProxy,
            SpeViewNStatamentProxy,
            SpeViewNCnabProxy,
            SpeNPaymentProxy,
            SpeViewNPaymentProxy
        ]
    })
], UiPxCashOutModule);

class AdvancedFilterVoucherDTO {
}
class AdvancedFilterTransactionScheduleDTO {
}

class ExtractConciliationCnabResponse {
    constructor(uuidLot, amountLine, nameFile, dateStart, dateEnd, dateProcess) {
        this.uuidLot = uuidLot;
        this.amountLine = amountLine;
        this.nameFile = nameFile;
        this.dateStart = dateStart;
        this.dateEnd = dateEnd;
        this.dateProcess = dateProcess;
    }
}

class AccountTransactionTrackApprovalDTO {
}
class ListApproves {
}

class ProcessCnabRequest {
}
class ProcessCnabResponse {
}

var TypeView;
(function (TypeView) {
    TypeView["DETAILADED"] = "DETAILADED";
    TypeView["CONSOLIDADED"] = "CONSOLIDADED";
})(TypeView || (TypeView = {}));

var TypeOperation;
(function (TypeOperation) {
    TypeOperation["C"] = "C";
    TypeOperation["D"] = "D";
    TypeOperation["T"] = "T"; //tarifa
})(TypeOperation || (TypeOperation = {}));

var ExportFormat;
(function (ExportFormat) {
    ExportFormat["XLSX"] = "xlsx";
    ExportFormat["OFX"] = "ofx";
    ExportFormat["PDF"] = "pdf";
})(ExportFormat || (ExportFormat = {}));

var TransactionApproveTypeOperationEnum;
(function (TransactionApproveTypeOperationEnum) {
    TransactionApproveTypeOperationEnum["ALL"] = "ALL";
    TransactionApproveTypeOperationEnum["TRANSFER"] = "TRANSFER";
    TransactionApproveTypeOperationEnum["PAYMENT"] = "PAYMENT";
})(TransactionApproveTypeOperationEnum || (TransactionApproveTypeOperationEnum = {}));
var TransactionApproveStatus;
(function (TransactionApproveStatus) {
    TransactionApproveStatus["ALL"] = "ALL";
    TransactionApproveStatus["FINISHED"] = "FINISHED";
    TransactionApproveStatus["PROCESSING"] = "PROCESSING";
    TransactionApproveStatus["PENDING"] = "PENDING";
    TransactionApproveStatus["REPROVED"] = "REPROVED";
    TransactionApproveStatus["NOT_AUTHORIZED"] = "NOT_AUTHORIZED";
    TransactionApproveStatus["CANCELED"] = "CANCELED";
})(TransactionApproveStatus || (TransactionApproveStatus = {}));
var codeOfOperationConsultEnum;
(function (codeOfOperationConsultEnum) {
    codeOfOperationConsultEnum["PAYMENT"] = "112";
    codeOfOperationConsultEnum["TRANSFER_ON_US"] = "901";
    codeOfOperationConsultEnum["TRANSFER_TED"] = "120";
})(codeOfOperationConsultEnum || (codeOfOperationConsultEnum = {}));

class PaymentLotDto {
    constructor() {
        this.data = [];
    }
}

class AbstractPaymentLotDetail {
}
class PaymentLotDetailHistory {
}
class PaymentLotDetailBillet extends AbstractPaymentLotDetail {
}
class PaymentLotDetailTransfer extends AbstractPaymentLotDetail {
}
class PaymentLotDetailTed extends PaymentLotDetailTransfer {
}
class PaymentLotDetailOnUs extends PaymentLotDetailTransfer {
}
class PaymentLotDetailPix extends PaymentLotDetailTransfer {
}

var PaymentLotTypeLotEnum;
(function (PaymentLotTypeLotEnum) {
    PaymentLotTypeLotEnum["BILLET"] = "BILLET";
    PaymentLotTypeLotEnum["TED"] = "TED";
    PaymentLotTypeLotEnum["ON_US"] = "ON_US";
    PaymentLotTypeLotEnum["PIX"] = "PIX";
})(PaymentLotTypeLotEnum || (PaymentLotTypeLotEnum = {}));
var PaymentLotTypeKeyPixEnum;
(function (PaymentLotTypeKeyPixEnum) {
    PaymentLotTypeKeyPixEnum["CPF"] = "CPF";
    PaymentLotTypeKeyPixEnum["CNPJ"] = "CNPJ";
    PaymentLotTypeKeyPixEnum["PHONE"] = "PHONE";
    PaymentLotTypeKeyPixEnum["EMAIL"] = "EMAIL";
    PaymentLotTypeKeyPixEnum["EVP"] = "EVP";
})(PaymentLotTypeKeyPixEnum || (PaymentLotTypeKeyPixEnum = {}));
var PaymentLotStatusLineEnum;
(function (PaymentLotStatusLineEnum) {
    PaymentLotStatusLineEnum["CREATE"] = "CREATE";
    PaymentLotStatusLineEnum["IN_PROCESS"] = "IN_PROCESS";
    PaymentLotStatusLineEnum["PROCESS_COMPLETED"] = "PROCESS_COMPLETED";
    PaymentLotStatusLineEnum["PROCESS_COMPLETED_WITH_ERROR"] = "PROCESS_COMPLETED_WITH_ERROR";
    PaymentLotStatusLineEnum["CANCELED"] = "CANCELED";
})(PaymentLotStatusLineEnum || (PaymentLotStatusLineEnum = {}));
var PaymentLotStatusDefaultEnum;
(function (PaymentLotStatusDefaultEnum) {
    PaymentLotStatusDefaultEnum["CREATE"] = "CREATE";
    PaymentLotStatusDefaultEnum["IN_PROCESS"] = "IN_PROCESS";
    PaymentLotStatusDefaultEnum["PROCESS_COMPLETED"] = "PROCESS_COMPLETED";
    PaymentLotStatusDefaultEnum["PROCESS_COMPLETED_WITH_ERROR"] = "PROCESS_COMPLETED_WITH_ERROR";
})(PaymentLotStatusDefaultEnum || (PaymentLotStatusDefaultEnum = {}));

export { AbstractPaymentLotDetail, AccountTransactionTrackApprovalDTO, AdvancedFilterTransactionScheduleDTO, AdvancedFilterVoucherDTO, ConfigService, ExportFormat, ExtractConciliationCnabResponse, ListApproves, PaymentLotDetailBillet, PaymentLotDetailHistory, PaymentLotDetailOnUs, PaymentLotDetailPix, PaymentLotDetailTed, PaymentLotDetailTransfer, PaymentLotDto, PaymentLotStatusDefaultEnum, PaymentLotStatusLineEnum, PaymentLotTypeKeyPixEnum, PaymentLotTypeLotEnum, ProcessCnabRequest, ProcessCnabResponse, SpeJCashOutProxy, SpeJCheckEventProxy, SpeJCnabProxy, SpeJFilesProxy, SpeJFundsProxy, SpeNAccountProxy, SpeNAccountsProxy, SpeNOpenAccountProxy, SpeNPaymentProxy, SpeNPaymentVoucherProxy, SpeViewNAccountProxy, SpeViewNBackoficceAccountProxy, SpeViewNCnabProxy, SpeViewNDashboardClientProxy, SpeViewNPaymentProxy, SpeViewNStatamentProxy, TransactionApproveStatus, TransactionApproveTypeOperationEnum, TypeOperation, TypeView, UiPxCashOutModule, codeOfOperationConsultEnum };
//# sourceMappingURL=wlp-ui-px-cashout.js.map
